<template>
	<v-container fluid>
		<div class="bottom-buttons-outer">
			<v-btn @click="backClick" color="success">
				<v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
			</v-btn>
			<v-btn @click="saveClick" color="success">
				<v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
			</v-btn>
		</div>
		<v-layout row wrap>
			<v-tabs class="xs12" v-model="tabId">
				<v-tab>{{ $t('tabs.general') }}</v-tab>
				<v-tab v-if="person.id!=0 && person.subject_type_id==1">{{ $t('tabs.buyerTours') }}</v-tab>
				<v-tab-item>
					<v-layout row wrap>
						<v-flex lg8 md12 pa-1 sm12 xl6 xs12>
							<v-card>
								<v-card-text>
									<v-layout row wrap>
										<v-flex md6 xs12>
											<v-layout row wrap>
												<v-flex xs12>
													<InputField :error="personValidation.first_name"
																:label="'* '+$t('fields.firstName')"
																v-model="person.first_name"></InputField>
												</v-flex>
												<v-flex xs12>
													<InputField :error="personValidation.last_name"
																:label="'* '+$t('fields.lastName')"
																v-model="person.last_name"></InputField>
												</v-flex>
												<v-flex xs12>
													<InputField :error="personValidation.address"
																:label="$t('fields.address')"
																v-model="person.address"></InputField>
												</v-flex>
												<v-flex xs12>
													<InputField :error="personValidation.city"
																:label="$t('fields.city')"
																v-model="person.city"></InputField>
												</v-flex>
												<v-flex xs12>
													<Dropdown
														:ajax="true"
														:data="'countries'" :error="personValidation.country_id"
														:label="'* '+$t('fields.country')"
														v-model="person.country_id"></Dropdown>
												</v-flex>
												<v-flex xs12>
													<Dropdown
														:ajax="true"
														:data="'companies'"
														:error="personValidation.company_id"
														:label="$t('fields.company')"
														v-model="person.company_id"></Dropdown>
												</v-flex>
												<v-flex xs12>
													<CheckBox
														:label="$t('fields.active')"
														v-model="person.active"></CheckBox>
												</v-flex>
											</v-layout>
										</v-flex>
										<v-flex md6 xs12>
											<v-layout row wrap>
												<v-flex xs12>
													<InputField :error="personValidation.phone"
																:label="$t('fields.phone')"
																v-model="person.phone"></InputField>
												</v-flex>
												<v-flex xs12>
													<InputField :error="personValidation.email"
																:label="$t('fields.email')"
																v-model="person.email"></InputField>
												</v-flex>
												<v-flex xs12>
													<InputField :error="personValidation.oib"
																:label="$t('fields.oib')"
																v-model="person.oib"></InputField>
												</v-flex>
												<v-flex xs12>
													<Dropdown
														:ajax="true"
														:data="'subject-types'"
														:error="personValidation.subject_type_id"
														:label="'* '+$t('fields.type')"
														:readonly="person.linked"
														v-model="person.subject_type_id"></Dropdown>
												</v-flex>
												<v-flex xs12>
													<TextArea
														:error="personValidation.notes"
														:label="$t('fields.notes')"
														v-model="person.notes"/>
												</v-flex>
												<v-flex xs12>
													<UploadMultiple :label="$t('fields.documents')"
																	v-model="person.documents"/>
												</v-flex>
												<v-flex v-if="person.id != 0" xs12>
													<DatePicker :dateLabel="$t('fields.dateAdded')" :readonly="true"
																v-model="person.date_added_display"/>
												</v-flex>
											</v-layout>
										</v-flex>
									</v-layout>
								</v-card-text>
							</v-card>
						</v-flex>
					</v-layout>
				</v-tab-item>
				<v-tab-item v-if="person.id!=0 && person.subject_type_id==1">
					<v-layout row wrap>
						<v-flex xs12>
							<v-card>
								<v-card-text>
									<v-layout row wrap>
										<v-spacer></v-spacer>
										<v-tooltip bottom>
											<v-btn @click="toggleToursFilter" icon slot="activator">
												<v-icon small>fa-filter</v-icon>
											</v-btn>
											<span>{{ $t('tooltips.filter') }}</span>
										</v-tooltip>
										<v-tooltip bottom>
											<v-btn @click="excelClick" icon slot="activator">
												<v-icon small>fa-file-excel</v-icon>
											</v-btn>
											<span>{{ $t('tooltips.excel') }}</span>
										</v-tooltip>
									</v-layout>
									<v-layout row wrap>
										<v-flex xs12>
											<v-data-table
												:headers="toursHeadersBuyers"
												:items="toursFiltered"
												:rows-per-page-items="[20, 30, 40]"
												class="elevation-0"
												must-sort
											>
												<template scope="props" slot="items">
													<tr v-if="props.item.id == null && toursFilterShown">
														<td>
															<InputField simple v-model="toursFilters.id"/>
														</td>
														<td>
															<InputField simple v-model="toursFilters.name"/>
														</td>
														<td>
															<Dropdown :ajax="true" :clearable="true"
																	  :data="'tour-categories'"
																	  simple v-model="toursFilters.tour_category_id"/>
														</td>
														<td>
															<Dropdown :ajax="true" :clearable="true"
																	  :data="'destinations'"
																	  simple v-model="toursFilters.destination_id"/>
														</td>
														<td>
															<DatePicker :clearable="true" simple
																		v-model="toursFilters.start_date"/>
														</td>
														<td>
															<Dropdown :ajax="true" :clearable="true" :data="'users'"
																	  simple
																	  v-model="toursFilters.user_id"/>
														</td>
														<td></td>
													</tr>
													<tr v-if="props.item.id != null">
														<td>{{ props.item.id }}</td>
														<td>{{ props.item.name }}</td>
														<td>{{ props.item.tour_category.name }}</td>
														<td>{{ props.item.destination }}</td>
														<td>{{ props.item.start_date_display }}</td>
														<td>{{ props.item.guides_display }}</td>
														<td class="text-xs-right">
															<v-btn
																@click="openTour(props.item.id)"
																color="primary"
																flat icon slot="activator">
																<v-icon small>fa-external-link-alt</v-icon>
															</v-btn>
														</td>
													</tr>
												</template>
											</v-data-table>
										</v-flex>
									</v-layout>
								</v-card-text>
							</v-card>
						</v-flex>
					</v-layout>
				</v-tab-item>
			</v-tabs>
		</v-layout>
	</v-container>
</template>

<script>
import InputField from "./trinkets/InputField";
import CheckBox from "./trinkets/CheckBox";
import Dropdown from "./trinkets/Dropdown";
import TextArea from "./trinkets/TextArea";
import UploadMultiple from "./trinkets/UploadMultiple";
import DatePicker from "./trinkets/DatePicker";

export default {
	name: "Person",
	components: {UploadMultiple, CheckBox, InputField, Dropdown, TextArea, DatePicker},
	props: {
		id: Number,
		action: String
	},
	data: function () {
		return {
			tabId: 0,
			initialLoad: false,
			person: {
				id: this.$route.params.id,
				first_name: '',
				last_name: '',
				address: '',
				city: '',
				country_id: null,
				phone: '',
				email: '',
				oib: '',
				subject_type_id: null,
				notes: '',
				documents: [],
				active: true,
				date_added: null,
				linked: false,
				company_id: null
			},
			personValidation: {
				id: '',
				first_name: '',
				last_name: '',
				address: '',
				city: '',
				country_id: '',
				phone: '',
				email: '',
				oib: '',
				subject_type_id: '',
				notes: '',
				documents: '',
				active: '',
				date_added: '',
				company_id: ''
			},
			toursHeadersBuyers: [
				{text: this.$t('fields.id'), value: 'id'},
				{text: this.$t('fields.name'), value: 'name'},
				{text: this.$t('fields.category'), value: 'category'},
				{text: this.$t('fields.destination'), value: 'destination'},
				{text: this.$t('fields.startDate'), value: 'start_date'},
				{text: this.$t('fields.guides'), value: 'guides'},
				{text: '', value: '', sortable: false}
			],
			toursFilters: {
				id: '',
				name: '',
				tour_category_id: null,
				destination_id: null,
				start_date: null,
				user_id: null
			},
			changesHappened: false,
			toursFilterShown: false
		}
	},
	computed: {
		toursFiltered() {
			let list = [{
				id: null
			}];

			for (let tour of this.person.tours) {
				let term = true;

				if (this.toursFilters.id != '') {
					if (tour.id != this.toursFilters.id) {
						term = false;
					}
				}

				if (this.toursFilters.name != '') {
					if (!tour.name.includes(this.toursFilters.name)) {
						term = false;
					}
				}

				if (this.toursFilters.tour_category_id != null) {
					if (tour.tour_category_id != this.toursFilters.tour_category_id) {
						term = false;
					}
				}

				if (this.toursFilters.destination_id != null) {
					if (tour.destination_id != this.toursFilters.destination_id) {
						term = false;
					}
				}

				if (this.toursFilters.start_date != null) {
					if (tour.start_date != this.toursFilters.start_date) {
						term = false;
					}
				}

				if (this.toursFilters.user_id != null) {
					let guideTerm = false;
					for (let guide of tour.guides) {
						if (guide.user_id == this.toursFilters.user_id) {
							guideTerm = true;
						}
					}
					if (!guideTerm) {
						term = false;
					}
				}

				let tour_tmp = JSON.parse(JSON.stringify(tour));

				tour_tmp.category = tour_tmp.tour_category.name;
				tour_tmp.destination = tour_tmp.destination.name;

				if (term) {
					list.push(tour_tmp);
				}
			}
			return list;
		}
	},
	watch: {
		person: {
			handler: function () {
				if (this.initialLoad) {
					this.changesHappened = true;
				}
			},
			deep: true
		},
	},
	methods: {
		toggleToursFilter() {
			this.toursFilterShown = !this.toursFilterShown;
			if (!this.toursFilterShown) {
				this.toursFilters = {
					id: '',
					name: '',
					tour_category_id: null,
					destination_id: null,
					start_date: null,
					user_id: null
				}
			}
		},
		excelClick() {
			this.$APICall('post', 'excel/people-buyer-tours', this.toursFiltered, (data, success) => {
				window.open(data.link);
			});
		},
		openTour(id) {
			let routeData = this.$router.resolve('/tours/' + id);
			window.open(routeData.href, '_blank');
		},
		backClick() {
			this.$router.go(-1);
		},
		saveClick() {
			let success = true;

			if (this.person.first_name == '') {
				success = false;
				this.personValidation.first_name = this.$t('alerts.fieldError');
			} else {
				this.personValidation.first_name = '';
			}
			if (this.person.last_name == '') {
				success = false;
				this.personValidation.last_name = this.$t('alerts.fieldError');
			} else {
				this.personValidation.last_name = '';
			}
			if (this.person.country_id == null) {
				success = false;
				this.personValidation.country_id = this.$t('alerts.fieldError');
			} else {
				this.personValidation.country_id = '';
			}
			if (this.person.subject_type_id == null) {
				success = false;
				this.personValidation.subject_type_id = this.$t('alerts.fieldError');
			} else {
				this.personValidation.subject_type_id = '';
			}
			if ((this.person.oib != '') && (this.person.country_id == 53)) {
				if (!(this.$checkOIB(this.person.oib))) {
					success = false;
					this.personValidation.oib = this.$t('alerts.oibError');
				} else {
					this.personValidation.oib = '';
				}
			} else {
				this.personValidation.oib = '';
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.person.id != 0) {
					action = 'put';
					addition = '/' + vm.person.id;
				}
				vm.$APICall(action, 'people' + addition, vm.person, (data, success) => {
					if (success) {
						vm.changesHappened = false;
						if (vm.person.id == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						vm.$triggerReload();
						vm.backClick();
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			}
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$setSubMenu('Lists');
		if (this.person.id != 0) {
			let vm = this;
			this.$APICall('get', 'people/' + this.person.id, {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data));
					usableData.subject_type_id = usableData.subject.subject_type_id;
					vm.person = usableData;
					vm.$myStore.commit('setBreadcrumbs', [
						{text: vm.$t('modules.people'), href: '/#/people', disabled: false},
						{
							text: vm.person.first_name + ' ' + vm.person.last_name,
							href: '/#/people/' + vm.person.id,
							disabled: true
						}
					]);
					vm.$nextTick(() => {
						vm.initialLoad = true;
					});
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		} else {
			this.$myStore.commit('setBreadcrumbs', [
				{text: this.$t('modules.people'), href: '/#/people', disabled: false},
				{text: this.$t('modules.newPerson'), href: '/#/people/0', disabled: true}
			]);
			this.initialLoad = true;
		}
	},
	beforeRouteLeave(to, from, next) {
		if (this.changesHappened) {
			this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
				next(result);
			});
		} else {
			next(true);
		}
	}
}
</script>

<style scoped>
</style>
